import { availabilityStates } from 'consts/availabilityStates';
import { sortIds } from 'consts/sort';
import clearObject from 'utils/clearObject';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const clearQuery = ({ product_id: productId, ...query }: Record<string, string>) =>
  clearObject({
    ...query,
    sort_id: sortIds.includes(Number(query.sort_id)) ? query.sort_id : undefined,
    price_from: Number(query.price_from) ? `${Number(query.price_from)}` : undefined,
    price_to: Number(query.price_to) ? `${Number(query.price_to)}` : undefined,
    is_available: availabilityStates.includes(query.is_available) ? query.is_available : undefined,
  }) as Record<string, string>;

export default clearQuery;
